import { graphql } from "./generated/index.js"

// Queries ======================================================================

/** A record's contacts, primary first, then by position, then oldest first. */
export const fetchRecordContacts = graphql(`
  query fetchRecordContacts($recordId: Int!) {
    contacts: record_contacts(
      where: { record_id: { _eq: $recordId } }
      order_by: [{ is_primary: desc }, { position: asc }, { created_at: asc }]
    ) {
      ...RecordContactFields
    }
  }
`)

// Mutations ====================================================================

export const addManyRecordContacts = graphql(`
  mutation addManyRecordContacts($objects: [record_contacts_insert_input!]!) {
    insert_record_contacts(objects: $objects) {
      returning {
        ...RecordContactFields
      }
    }
  }
`)

export const updateRecordContact = graphql(`
  mutation updateRecordContact($id: Int!, $_set: record_contacts_set_input!) {
    update_record_contacts_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...RecordContactFields
    }
  }
`)

export const updateManyRecordContacts = graphql(`
  mutation updateManyRecordContacts($updates: [record_contacts_updates!]!) {
    update_record_contacts_many(updates: $updates) {
      affected_rows
      returning {
        ...RecordContactFields
      }
    }
  }
`)

export const deleteManyRecordContacts = graphql(`
  mutation deleteManyRecordContacts($ids: [Int!]!) {
    delete_record_contacts(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)

export const unsetOtherPrimaryContacts = graphql(`
  mutation unsetOtherPrimaryContacts($recordId: Int!, $excludeId: Int!) {
    update_record_contacts(
      where: { record_id: { _eq: $recordId }, id: { _neq: $excludeId } }
      _set: { is_primary: false }
    ) {
      affected_rows
    }
  }
`)
